var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-marvin-info-box",class:`bc-marvin-info-box--${_vm.type}`},[_c('div',[_c(_setup.MarvinType,{tag:"component",staticClass:"c-marvin"})],1),_c(_setup.BCXMarkdown,{staticClass:"infotext",attrs:{"tag":"div","text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }